module.exports = __webpack_public_path__ + "static/banner-postre-bfb6691d432f9548461f1f73c6fe0eff.jpg";